
import ResearchOrganizationRepositoryAPI from "@/modules/research-organization/research-organization-repository-api";
import UserRepositoryAPI from "@/modules/user/user-repository-api";
import axios from "@/services/axios";
import { lazyParamsDefault } from "@/utils/pagination-helper";
import { FilterMatchMode } from "primevue/api";
import { computed, defineComponent, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  setup() {
    const { t } = useI18n();
    const filters = reactive({
      name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const { setResearchOrganization, loadItems, loadItem } =
      ResearchOrganizationRepositoryAPI();
    const {
      hasBriumAccessRole,
      hasUniversityAccessRole,
      hasFacultyAccessRole,
      getUser,
    } = UserRepositoryAPI();

    const state = reactive({
      users: [],
      selectedRow: [],
      editingRows: [],
      dataLoading: true,
      organizationGroup: [] as Array<any>,
      lazyParams: lazyParamsDefault,
      keywords: "",
    });

    const onRowSelect = (event: any): void => {
      setResearchOrganization(event.data);
    };

    const onPaginatorResearchEquipmentClick = (event: any): void => {
      state.lazyParams = event;
      const researchOrganizationId = getUser.value.researchOrganizationId;
      if (hasBriumAccessRole() || hasUniversityAccessRole()) {
        loadItems(state);
      } else if (hasFacultyAccessRole() && researchOrganizationId) {
        loadItem(state, researchOrganizationId);
      }
    };

    async function loadUsers() {
      const response = await axios.get("api/v1/User?PageNumber=0&PageSize=500");
      state.users = response.data;
    }

    onMounted(() => {
      loadUsers();
      onPaginatorResearchEquipmentClick(state.lazyParams);
    });

    return {
      t,
      onRowSelect,
      filters,
      state: computed(() => state),
      onPaginatorResearchEquipmentClick,
    };
  },
});
